import _ from "lodash";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CustomBreadCrum } from "../common/CustomBreadcrum";
import ExportSelectedRows from "../ExportCSV";
import searchMyProjects from "../../assets/images/searchMyProjects.svg";
import searchMyProjectsClicked from "../../assets/images/searchMyProjectsClicked.svg";
import filter from "../../assets/images/filter.svg";
import BlueFilterIcon from "../../assets/images/BlueFilterIcon.svg";
import WrapIcon from "../../assets/images/wrap-icon.png";
import { Button } from "react-bootstrap";

function DesignJobHeader({
  projectName,
  headerName,
  loader,
  hyperLink,
  designJobsData,
  filterDesignJobsData,
  columnNames,
  filename,
  designJobWrapFreeText,
  setDesignJobWrapFreeText,
  onSearchClick = null,
  isFilterEnabled,
  onChildClick,
  projectState,
  setVisible,
  selectedJobsData,
  onDownloadClick
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const locationPath = location?.pathname;
  const url = locationPath?.split("/");
  const [isClicked, setIsClicked] = useState(false);

  // needs to pass this data in Custom Breadcrum
  const items = [
    { label: _.startCase(url[1]), url: `/${url[1]}` },
    { label: headerName, url: "" },
    { label: !loader && projectName, url: hyperLink },
  ];

  const handleClick = () => {
    const newIsClicked = !isClicked;
    setIsClicked(!isClicked);
    onSearchClick();

    if (onChildClick) {
      onChildClick(newIsClicked);
    }
  };

  const handleClearFilter = () => {
    const newIsClicked = !isFilterEnabled;
    setIsClicked(newIsClicked);

    if (onChildClick) {
      onChildClick(newIsClicked);
    }
  };

  return (
    <>
      <div className="actions">
        <div>
          {/* breadcrumb */}
          <CustomBreadCrum
            items={items}
            iconColorBlack={true}
            lastChildSecondChild={false}
            lastLabel={"designJob"}
          />
        </div>
        <div className="header-buttons">
          <div style={{ top: 30 }}>
            <button
              className="downloadAll-btn mx-1"
              disabled={selectedJobsData?.length === 0}
              onClick={() => onDownloadClick()}
            >
              <i className="pi pi-download fs-4"></i>
            </button>
            <img
              src={filterDesignJobsData.length ? BlueFilterIcon : filter}
              alt="filter logo"
              onClick={() => (filterDesignJobsData.length ? handleClearFilter() : null)}
              className="header-icons"
            />
            <img
              src={isClicked ? searchMyProjects : searchMyProjectsClicked}
              alt="search field"
              onClick={handleClick}
              className="header-icons"
            />
            <span style={{ marginLeft: 20, marginRight: 25 }}>
              <ExportSelectedRows
                allData={designJobsData}
                selectedRows={filterDesignJobsData}
                headers={columnNames}
                filename={filename}
              />
            </span>
            <img
              src={WrapIcon}
              alt={designJobWrapFreeText ? "Unwrap Free Text" : "Wrap Free Text"}
              title={designJobWrapFreeText ? "Unwrap Free Text Columns" : "Wrap Free Text Columns"}
              onClick={() => setDesignJobWrapFreeText((prev) => !prev)}
              style={{
                cursor: "pointer",
                marginRight: "10px",
                width: "20px",
                height: "20px",
                filter: designJobWrapFreeText ? "none" : "grayscale(100%)",
              }}
            />
          </div>
          <Button
            onClick={() => navigate(`${locationPath}/rework`)}
            disabled={projectState === "Complete"}
          >
            Rework
          </Button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setVisible(true)}
          >
            Customize View
          </button>
        </div>
      </div>
    </>
  );
}

export default DesignJobHeader;
